module.exports = __webpack_public_path__ + "img/external-link.468260df911d18f415afd6f496c22a73.svg";